import React from "react";
import useInput from "@ui/lib/hooks/useInput";
import t from "../../i18n";
import type { Project } from "../../api/useProjects";

export const useDescriptionInput = (projects: Project[]) => {
  const hasSameValue = React.useMemo(
    () => [...new Set(projects.map(p => p.description).filter(d => d !== undefined))].length === 1,
    [projects],
  );

  const defaultValue = React.useMemo(() => {
    if (hasSameValue) return projects[0]?.description ?? undefined;
    return;
  }, [hasSameValue, projects]);

  const {
    value: description,
    setValue: setDescription,
    onChange: handleDescriptionChanged,
    dirty: isDescriptionDirty,
    defaultValue: descriptionDefaultValue,
  } = useInput(defaultValue);

  const placeholder = React.useMemo(() => {
    if (!hasSameValue && projects.length > 1) {
      return t("projects.modal.multiple_value");
    }

    return defaultValue ?? "Description";
  }, [defaultValue, hasSameValue, projects.length]);

  return {
    placeholder,
    description,
    setDescription,
    handleDescriptionChanged,
    isDescriptionDirty,
    descriptionDefaultValue,
  };
};
